import type { WarehouseProblem } from '@server/warehouse-failure';

/** The lines a support ticket needs, in one block. */
export function supportText(problem: WarehouseProblem): string {
  return [
    problem.supportId && `Support code: ${problem.supportId}`,
    problem.code && `Error code: ${problem.code}`,
    problem.vendorRequestId && `Warehouse request ID: ${problem.vendorRequestId}`,
    problem.details && `Details: ${problem.details}`,
  ]
    .filter(Boolean)
    .join('\n');
}
